import { render } from "./CartResultMessagePage.vue?vue&type=template&id=15bb543b"
import script from "./CartResultMessagePage.vue?vue&type=script&lang=js"
export * from "./CartResultMessagePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__